// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  justify-content: space-between;
  list-style: none;
  cursor: pointer;
  grid-column-gap: 5px;
}

.pagination li {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.pagination a {
  padding: 6px 12px;
  line-height: 28px;
}

.paginationItem {
  display: flex;
  align-items: center;
  justify-content: center;
  /* color: #505050; */
  font-weight: normal;
  &:hover {
    color: #007C8A;
  }
}

.paginationLink {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  /* color: #2D3748; */
  &:hover {
    color: #007C8A;
  }
}

.paginationActive {
  color: #007C8A !important;
  font-weight: bold !important;
}

.paginationDisabled {
  color: #2D3748;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/config/component/pagination/pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".pagination {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  list-style: none;\r\n  cursor: pointer;\r\n  grid-column-gap: 5px;\r\n}\r\n\r\n.pagination li {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.pagination a {\r\n  padding: 6px 12px;\r\n  line-height: 28px;\r\n}\r\n\r\n.paginationItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* color: #505050; */\r\n  font-weight: normal;\r\n  &:hover {\r\n    color: #007C8A;\r\n  }\r\n}\r\n\r\n.paginationLink {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  /* color: #2D3748; */\r\n  &:hover {\r\n    color: #007C8A;\r\n  }\r\n}\r\n\r\n.paginationActive {\r\n  color: #007C8A !important;\r\n  font-weight: bold !important;\r\n}\r\n\r\n.paginationDisabled {\r\n  color: #2D3748;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
